import APIService from 'src/services/APIService'

const api = APIService()

export const createCoreValue = payload => api.post('/core-values', payload)
export const updateCoreValue = payload => api.patch(`/core-values/${payload.id}`, payload)
export const deleteCoreValue = id => api.delete(`/core-values/${id}`)
export const fetchCoreValues = () => api.get('/core-values')
